import { render, staticRenderFns } from "./TeamManager.vue?vue&type=template&id=077dd8fe&scoped=true"
import script from "./TeamManager.vue?vue&type=script&lang=ts"
export * from "./TeamManager.vue?vue&type=script&lang=ts"
import style0 from "./TeamManager.vue?vue&type=style&index=0&id=077dd8fe&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "077dd8fe",
  null
  
)

export default component.exports